import {
  Action,
  ControlType,
} from "@/context/AnalyticsProvider/AnalyticsProvider";
import { GamePageSection } from "@/context/AnalyticsProvider/gamePage";
import { useGameDetailsContext } from "@/context/GameDetailsContext";
import { GlassButton } from "../GlassButton";
import type { GPOnboardingStepProps } from "./utils";

export const FinalReward = ({ onNext, track }: GPOnboardingStepProps) => {
  const { gameData } = useGameDetailsContext();

  const handleClick = () => {
    track({
      action: Action.PRESSED,
      extras: {
        control: "back-to-game",
        controlLabel: `Back to ${gameData.gameContent?.name_short}`,
        controlType: ControlType.BUTTON,
        section: GamePageSection.ONBOARDING_MODAL,
      },
    });

    onNext();
  };

  return (
    <div className="flex-grow flex flex-col items-center justify-between gap-y-10">
      {/* Title */}
      <div>
        <h2 className="text-[clamp(1.25rem,6.25vw,1.875rem)] font-bold leading-[clamp(1.5rem,6.25vw,2.25rem)] text-center">
          Reward upgraded to
          <br />
          Gold tier
        </h2>
      </div>

      {/* Button */}
      <GlassButton
        control="back-to-game"
        section={GamePageSection.ONBOARDING_MODAL}
        onClick={handleClick}
        variant="cta"
        className="!h-auto w-full px-20 py-3 mt-2 min-h-[3rem]"
      >
        Back to {gameData.gameContent?.name_short}
      </GlassButton>
    </div>
  );
};
